var viewer_caption_default = {
  "fontElementMap": "EIwyL",
  "imageCaption": "Hyrqd"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
